/**
 * Configuración de la URL base de la API
 * 
 * Lógica de detección de entorno:
 * 1. Si REACT_APP_API_URL tiene valor explícito (del .env), lo usa
 * 2. Si está en desarrollo (puerto 3000), apunta a Flask en puerto 5000
 * 3. En producción, usa rutas relativas (React servido por Flask)
 */

export const getApiUrl = () => {
    const envUrl = process.env.REACT_APP_API_URL;
    
    // 1. Si el .env tiene una URL explícita (no vacía), la usamos
    if (envUrl && envUrl.trim() !== "") {
        return envUrl;
    }

    // 2. Modo desarrollo (npm start) - React en 3000, Flask en 5000
    if (window.location.port === '3000') {
        return `http://${window.location.hostname}:5000`;
    }

    // 3. Modo producción - rutas relativas
    return "";
};

export const API_URL = getApiUrl();

const R2_PUBLIC_URL = process.env.REACT_APP_R2_PUBLIC_URL || 'https://pub-2c1836fc148347efa9ce9300e0bb3cb5.r2.dev';

const config = {
    api_url: API_URL,
    img_defecto: process.env.REACT_APP_IMG_DEFECTO || '/imgs/defecto.png',
    r2_public_url: R2_PUBLIC_URL,
    google_api: process.env.REACT_APP_GOOGLE_API_KEY || '',
};

// Arma la URL pública de una imagen guardada en R2 a partir del key
// devuelto por el backend (ej: "5/productos/173_ab12.webp").
// Si `key` ya es una URL absoluta, la retorna sin modificar.
export const resolveImagenUrl = (key) => {
    if (!key) return null;
    if (key.startsWith('http') || key.startsWith('data:')) return key;
    const keyLimpio = key.startsWith('/') ? key.substring(1) : key;
    return `${R2_PUBLIC_URL}/${keyLimpio}`;
};

export default config;
